import React from "react";
import Markdown from "markdown-to-jsx";

const RichText: React.FC<{ children: string; className?: string }> = ({
  children,
  className,
}) => (
  <Markdown
    className={className}
    options={{ disableParsingRawHTML: true, forceBlock: true }}
  >
    {children}
  </Markdown>
);

export default RichText;
